import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Quicks from '../../components/quicks';
import MDParser from '../../components/md-parser';
import Social from '../../components/social-box';

import './index.css';

const Component = () => {
    const { username } = useParams();
    const [biography, setBiography] = useState();

    useEffect(() => {
        // GET Biography
        fetch(`${process.env.PUBLIC_URL}/_data/people/biography/${username}.md`)
            .then((res) => res.text())
            .then((reply) => {
                setBiography(reply);
            });
    }, []);

    const profileURL = `${process.env.PUBLIC_URL}/_data/people/people.json`;

    const [info, setInfo] = useState({
        name: '',
        username: '',
        role: '',
        email: '',
        website: '',
        github: '',
        googleScholar: '',
        linkedIn: '',
        currentMember: true
    });

    useEffect(() => {
        // GET QuickLinks
        fetch(profileURL)
            .then((res) => res.json())
            .then((reply) => {
                setInfo(reply.filter((person) => person.username === username)[0]);
            });
    }, []);

    return (
        <div className="row">
            <Quicks external links={[{ name: 'People', link: 'people' }]} navs={[]} />
            <div className="row profile-content  justify-content-center">
                <div className="profile-col-1 col-sm-3">
                    <div
                        className="profile-picture "
                        style={{
                            backgroundImage: `url(${process.env.PUBLIC_URL}/_static/people/${username}.jpg)`
                        }}
                    />
                    <Social
                        github={info.github}
                        linkedIn={info.linkedIn}
                        googleScholar={info.googleScholar}
                        mail={info.email}
                        website={info.website}
                    />
                </div>

                <div className="col-sm-1">&nbsp;</div>
                <div className="col-sm-7">
                    <h3>{info.name}</h3>
                    <p className="profile-role">{info.role}</p>
                    <MDParser content={biography} />
                </div>
            </div>
        </div>
    );
};

export default Component;
